import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import { ApplySvg, CloseSvg, RightSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { Template } from "@/components";
import clsx from "clsx";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { TGroup, TTemplate } from "@/types";
import { useEffect, useState } from "react";
import FTAnalytic from "@/analyze/FTAnalytic";
import {
  FTSwapAnalyzeObj,
  MULTI_TEMP_HEIGHT,
  MULTI_TEMP_WIDTH,
  PROJECT_TYPE,
  SINGLE_TEMP_HEIGHT,
  SINGLE_TEMP_WIDTH,
} from "@/constants";
import WaterFall from "../CustomWaterFall";
import WaterFallSon from "../CustomWaterFall/waterfallSon";
import { FeatureType } from "@/stores/useCommonStore";
import { useMediaQuery } from "@/hooks";

interface AllPresetPanelProps {
  showHeader?: boolean;
  onSelect?: () => void;
}
const AllPresetPanel = (props: AllPresetPanelProps) => {
  const { showHeader = true } = props;
  const { t } = useTranslation();

  const [activeTemp, setActiveTemp] = useState<TTemplate>();

  const isMobile = useCommonStore((state) => state.isMobile);
  const presetGroupList = useCommonStore((state) => state.presetGroupList);
  const featureType = useCommonStore((state) => state.featureType);
  const presetMultiGroupList = useCommonStore(
    (state) => state.presetMutiGroupList
  );
  const activeGroup = useCommonStore((state) => state.activeGroup);
  const activeMutiGroup = useCommonStore((state) => state.activeMutiGroup);
  const setAllPresetVisible = useCommonStore(
    (state) => state.setAllPresetVisible
  );
  const setActiveGroup = useCommonStore((state) => state.setActiveGroup);
  const setActiveMutiGroup = useCommonStore(
    (state) => state.setActiveMutiGroup
  );
  const chooseTemp = useCommonStore((state) => state.chooseTemp);
  const isPad = useMediaQuery({
    query: "(max-width: 960px) and (min-width: 768px)",
  });

  const handleClickTemp = (temp: TTemplate) => {
    if (isMobile) {
      setActiveTemp(temp);
      chooseTemp(temp);
    } else {
      chooseTemp(temp);
    }
    props.onSelect?.();
  };

  const handleApply = () => {
    if (activeTemp) {
      chooseTemp(activeTemp);
      if (isMobile) {
        setAllPresetVisible(false);
      }
    }
  };

  const handleClickGroup = (value: TGroup) => {
    if (featureType === FeatureType.Single) {
      setActiveGroup(value);
    } else {
      setActiveMutiGroup(value);
    }

    // 埋点（切换分组）
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_features",
      label: {
        project_type: PROJECT_TYPE,
        button_position: FTSwapAnalyzeObj.Switch_packets,
      },
    });
  };

  useEffect(() => {
    setActiveTemp(isMobile ? activeGroup?.tempList[0] : undefined);
  }, [isMobile, activeGroup]);
  const isSingle = featureType === FeatureType.Single;
  const list = isSingle ? presetGroupList : presetMultiGroupList;
  const activeGG = isSingle ? activeGroup : activeMutiGroup;
  const width = isSingle ? SINGLE_TEMP_WIDTH : MULTI_TEMP_WIDTH;
  const height = isSingle ? SINGLE_TEMP_HEIGHT : MULTI_TEMP_HEIGHT;
  return (
    <div className={styles["root"]}>
      <OverlayScrollbarsComponent
        className={styles["custom_scrollbar"]}
        style={{}}
        defer
      >
        <div className={styles["header"]}>
          {showHeader && (
            <div className={styles["title_row"]}>
              <button
                className={styles["back_button"]}
                onClick={() => setAllPresetVisible(false)}
              >
                {isMobile ? (
                  <CloseSvg></CloseSvg>
                ) : (
                  <>
                    <RightSvg></RightSvg>
                    <span>{t("back_button")}</span>
                  </>
                )}
              </button>

              <span className={styles["title"]}>
                {t("all_preset_panel_title")}
              </span>

              {isMobile && (
                <button
                  className={styles["apply_button"]}
                  onClick={handleApply}
                >
                  <ApplySvg></ApplySvg>
                </button>
              )}
            </div>
          )}

          {list.length > 1 && (
            <div className={styles["group_row"]}>
              <ul className={clsx(styles["group_list"], "hide_scrollbar")}>
                {list.map((item) => (
                  <li
                    key={item.id}
                    className={clsx(
                      styles["group_item"],
                      activeGG?.id === item.id && styles["active"]
                    )}
                  >
                    <button
                      className={styles["group_button"]}
                      onClick={() => handleClickGroup(item)}
                    >
                      <span>{item.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className={styles["body"]}>
          <div className={styles["temp_grid"]}>
            <WaterFall column={isMobile ? 3 : isPad ? 3 : 4}>
              {activeGG?.tempList?.map((item) => (
                <WaterFallSon
                  key={item.id}
                  width={item.dimension?.width ?? width}
                  height={item.dimension?.height ?? height}
                >
                  <Template
                    key={item.id}
                    {...item}
                    isActive={activeTemp?.id === item.id}
                    onClick={() => handleClickTemp(item)}
                    className={styles["temp_grid_item"]}
                    onLoad={(size) => {
                      if (!item.dimension) {
                        item.dimension = {
                          width: size.width,
                          height: size.height,
                        };
                      } else {
                        item.dimension.height = size.height;
                        item.dimension.width = size.width;
                      }
                      if (isSingle) {
                        setActiveGroup({
                          ...activeGG,
                        });
                      } else {
                        setActiveMutiGroup({
                          ...activeGG,
                        });
                      }
                    }}
                  ></Template>
                </WaterFallSon>
              ))}
            </WaterFall>
            {/* {activeGroup?.tempList.map((item) => (
              <Template
                key={item.id}
                {...item}
                isActive={activeTemp?.id === item.id}
                onClick={() => handleClickTemp(item)}
              ></Template>
            ))} */}
          </div>
        </div>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default AllPresetPanel;
